const GENERIC_UPLOAD_ERROR =
  'Upload failed. Please check your connection and try again.';

const toUploadErrorMessages = (error: any): string[] => {
  const data = error?.response?.data ?? error;

  if (
    !data ||
    typeof data !== 'object' ||
    ['No response', 'Unhandled error'].includes(data.error)
  ) {
    return [GENERIC_UPLOAD_ERROR];
  }

  const messages = Object.values(data)
    .flat()
    .map((value) => (typeof value === 'string' ? value : GENERIC_UPLOAD_ERROR));

  return messages.length
    ? Array.from(new Set(messages))
    : [GENERIC_UPLOAD_ERROR];
};

export default toUploadErrorMessages;
